if (!customElements.get("product-modal")) {
    class ProductModal extends ModalDialog {
        constructor() {
            super();
            this.bodyClass = "product-modal__opened";
            window.addEventListener("popstate", (event) => {
                this.hasAttribute("open") && this.hide();
            });
        }

        hide() {
            super.hide();
            document.body.classList.remove(this.bodyClass);
            window.pauseAllMedia();
        }

        show(opener) {
            window.location.hash = "product-modal";
            super.show(opener);
            document.body.classList.add(this.bodyClass);
            this.showActiveMedia();
        }

        showActiveMedia() {
            this.querySelectorAll(
                `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute(
                    "data-media-id"
                )}"])`
            ).forEach((element) => {
                element.classList.remove("active");
            });
            const activeMedia = this.querySelector(
                `[data-media-id="${this.openedBy.getAttribute(
                    "data-media-id"
                )}"]`
            );
            activeMedia.classList.add("active");
            activeMedia.scrollIntoView();

            if (
                activeMedia.nodeName == "DEFERRED-MEDIA" &&
                activeMedia
                    .querySelector("template")
                    ?.content?.querySelector(".js-youtube")
            )
                activeMedia.loadContent();
        }
    }

    customElements.define("product-modal", ProductModal);
}
